import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-images-new',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnDestroy {

  url = '';
  sanitizedUrl = '';


  value: any;

  @Input() type: any;

  @Input() finalValue: any;

  @Output() sendValue = new EventEmitter();

  imageVisible: boolean = true;

  public serverPath = environment.commonImageApi + 'image/';

  text: string;

  constructor(private snackBar: MatSnackBar,
    private productService: ProductService,
    private downloadImageService: DownloadImageService, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {

    this.text = "Save"
    this.value= this.finalValue;
  }


  logo() {
    this.imageVisible = false;
  }

  imageDelete: boolean;
  imagesToRemoved: any = [];


  deleteImage() {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/image/" + this.finalValue;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"
          this.imageVisible = true;
          this.imageDelete = false;
          this.finalValue='';
          this.value = '';
          this.sendValue.emit(this.finalValue);
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;

          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }



  getResult(event) {
    this.imageVisible = true;

    this.finalValue=event.productEntityMediaGallery[0].fileName
   
    this.value= this.finalValue;

    this.sendValue.emit(this.value);
  }

  cancelUpload() {
    this.imageVisible = true;
  }

  downloadImage1(path) {

    this.downloadImageService.downloadImageNew1(path);

  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

